import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppSettingsService } from '../../services/app-settings.service';
import { CartService } from '../../services/cart.service';

@Component({
  selector: 'app-table-switch-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './table-switch-modal.html',
})
export class TableSwitchModalComponent {
  public cartService = inject(CartService);
  public settingsService = inject(AppSettingsService);
  private router = inject(Router);

  pending = this.cartService.pendingTableSwitch;

  currentTableName = computed(() => {
    const p = this.pending();
    if (!p) return '';
    const currentTable = this.settingsService.currentTable();
    if (currentTable && currentTable.id === p.currentTableID) {
      return currentTable.Name;
    }
    return p.currentTableID;
  });

  newTableName = computed(() => {
    const p = this.pending();
    if (!p) return '';
    return p.newTableName || p.newTableID;
  });

  confirm() {
    const p = this.pending();
    if (p) {
      const newId = p.newTableID;
      this.cartService.confirmTableSwitch();
      this.router.navigate([], {
        queryParams: { tableID: newId },
        queryParamsHandling: 'merge',
      });
    }
  }

  cancel() {
    const p = this.pending();
    if (p) {
      const currentId = p.currentTableID;
      this.cartService.cancelTableSwitch();
      this.router.navigate([], {
        queryParams: { tableID: currentId },
        queryParamsHandling: 'merge',
      });
    }
  }
}
